import React from "react";

const Footer = () => {
  return <footer className="footer">This is a demo of a web of pokemon made with React by César Alba (26/02/2023).</footer>;
}

export default Footer;
